import * as React from "react";
import Moment from "moment";
import { connect } from "react-redux";
import { Button, Col, Form } from "react-bootstrap";
import { UserInfo, hasPermission } from "../../Login/common/defaults";
import { eCheckersQueue } from "./controller/CheckersQueueController";
import { DateRangePicker } from "react-dates";
import { extendMoment } from "moment-range";
import * as urls from "../../shared/urls";
import {
  searchCheckersPaged,
  openReportById,
  assignAndOpen,
  unAssign,
  getCheckerReports
} from "./redux-objects/actions";
import "./assets/checkersQueue.scss";
import {
  IExportColumnMap,
  PagedResultsRequest
} from "../../../common/sharedTypes";
import * as documentDownloadService from "../../../services/documentDownloadService";
import { toast } from "react-toastify";
import { getFrontSheetData } from "../../PrintPDF/redux-objects/actions";
import ViewAllButton from "../../DocumentViewer/ViewAllButton";
import { Provider } from "react-redux";
import store from "../../../store/Store";
import rootReducer from "../../../store/Reducers";
import MergedIndicator from "../common/MergedIndicator";
import CompletedIndicator from "../common/CompletedIndicator";
import { QueueStartDate } from "../common";
import PagedDatatable from "../../PagedDataTable";
import { TableColumn } from "react-data-table-component/dist/DataTable/types";
import {
  CheckersQueueItem,
  SearchCheckersQueuePagedRequest
} from "./business-objects/common";
import LocalStorageUtils from "../common/LocalStorageUtils";
import DriverReportMergedIndicator from "../common/DriverReportMergedIndicator";
const reduxStore = store({}, rootReducer);
const moment = extendMoment(Moment);

interface ICheckersQueuePagedFromState {
  currentUser: UserInfo;
  webServiceURL: string;
  history: any;
  queueToShow: eCheckersQueue;
  queueItems: CheckersQueueItem[];
  loadingWorkflowSteps: boolean;
  totalWorkflowItemSteps: number;
}

interface ICheckersQueuePagedFromActions {
  searchCheckersPaged?: (
    url: string,
    request: SearchCheckersQueuePagedRequest
  ) => void;
  openReportById?: (
    workflowItemStepId: number,
    callback?: () => void
  ) => Promise<void>;
  assignAndOpen?: (
    url: string,
    stepItemId: number,
    assignToId: number
  ) => Promise<void>;
  unAssign?: (url: string, stepItem: any) => Promise<void>;
  getFrontSheetData?: (url: string, reportId: any) => Promise<any>;
}

interface ICheckersQueuePagedLocalState {
  showModal: boolean;
  startDate: Moment.Moment;
  endDate: Moment.Moment;
  focusedInput: any;
  showCheckers: boolean;
  selectedItem: any;
  formIsReadOnly: boolean;
  userOnly: boolean;
  assignedOnly: boolean;
  unassignedOnly: boolean;
  pagingCriteria: PagedResultsRequest;
}

type ICheckersQueuePagedProps = ICheckersQueuePagedFromActions &
  ICheckersQueuePagedFromState;

export class CheckersQueuePaged extends React.Component<
  ICheckersQueuePagedProps,
  ICheckersQueuePagedLocalState
> {
  constructor(props: ICheckersQueuePagedProps) {
    super(props);

    this.state = {
      showModal: false,
      startDate: moment(QueueStartDate),
      endDate: moment(),
      focusedInput: null,
      showCheckers: false,
      selectedItem: null,
      formIsReadOnly: false,
      userOnly: false,
      assignedOnly: false,
      unassignedOnly: false,
      pagingCriteria: {
        itemsPerPage: 10,
        pageNumber: 1,
        searchCriteria: null,
        orderByField: "PriorityNumber",
        orderDescending: false
      }
    };
  }

  private assignedOnlyVariable: string = "CheckersAssignedOnlyCheckbox";
  private userOnlyVariable: string = "CheckersUserOnlyCheckbox";
  private startDateVariable: string = "CheckersStartDate";
  private endDateVariable: string = "CheckersEndDate";
  private unassignedOnlyVariable: string = "CheckersUnassignedOnlyCheckbox";

  onViewPdfClick = () => {
    window.open("/Form40.pdf");
  };

  openReportToRead = (cellData, rowData) => {
    this.setState({ selectedItem: cellData, showCheckers: true });
  };

  handleAssignAndOpen(rowData: CheckersQueueItem) {
    if (rowData.assignedToUserId == this.props.currentUser.id) {
      this.props.openReportById(rowData.id, () => {
        this.props.history.push("/CheckerReview");
      });
    } else {
      this.props
        .assignAndOpen(
          urls.ASSIGN_WORKFLOW_ITEM_STEP,
          rowData.id,
          this.props.currentUser.id
        )
        .then(() => {
          this.props.history.push("/CheckerReview");
        });
    }
  }

  handleOpenImage(crashId: number, docId: string) {
    documentDownloadService.openOnBaseImage(crashId, docId).then((x) => {
      if (x === "generated") {
        toast.info("OnBase Image not found - Image generated from data", {
          autoClose: false
        });
      } else if (x === "mock") {
        toast.info("OnBase mocked - Image generated from data", {
          autoClose: false
        });
      }
    });
  }

  loadCheckers() {
    const { webServiceURL } = this.props;
    const uri = `${webServiceURL}${urls.SEARCH_CHECKERS_QUEUE_PAGED}`;
    const persistentUserOnly = LocalStorageUtils.getLocalStorageBool(
      this.userOnlyVariable
    );
    const persistentAssignedOnly = LocalStorageUtils.getLocalStorageBool(
      this.assignedOnlyVariable
    );
    const persistentStartDate = LocalStorageUtils.getLocalStorageDate(
      this.startDateVariable
    );
    const persistentEndDate = LocalStorageUtils.getLocalStorageDate(
      this.endDateVariable
    );
    const persistentUnassignedOnly = LocalStorageUtils.getLocalStorageBool(
      this.unassignedOnlyVariable
    );

    const request: SearchCheckersQueuePagedRequest = {
      ...this.state.pagingCriteria,
      userOnly: persistentUserOnly ? persistentUserOnly : false,
      assignedOnly: persistentAssignedOnly ? persistentAssignedOnly : false,
      unassignedOnly: persistentUnassignedOnly ? persistentUnassignedOnly : false,
      startDate: persistentStartDate
        ? persistentStartDate.toDate().toUTCString()
        : this.state.startDate.toDate().toUTCString(),
      endDate: persistentEndDate
        ? persistentEndDate.toDate().toUTCString()
        : this.state.endDate.toDate().toUTCString(),
      workflowStatus: 1
    };
    this.props.searchCheckersPaged(uri, request);
  }

  getExportData = async (): Promise<CheckersQueueItem[]> => {
    const { webServiceURL } = this.props;
    const uri = `${webServiceURL}${urls.SEARCH_CHECKERS_QUEUE_PAGED}`;
    const persistentUserOnly = LocalStorageUtils.getLocalStorageBool(
      this.userOnlyVariable
    );
    const persistentAssignedOnly = LocalStorageUtils.getLocalStorageBool(
      this.assignedOnlyVariable
    );
    const persistentStartDate = LocalStorageUtils.getLocalStorageDate(
      this.startDateVariable
    );
    const persistentEndDate = LocalStorageUtils.getLocalStorageDate(
      this.endDateVariable
    );
    const persistentUnassignedOnly = LocalStorageUtils.getLocalStorageBool(
      this.unassignedOnlyVariable
    );

    const request: SearchCheckersQueuePagedRequest = {
      ...this.state.pagingCriteria,
      itemsPerPage: this.props.totalWorkflowItemSteps,
      pageNumber: 1,
      userOnly: persistentUserOnly ? persistentUserOnly : false,
      assignedOnly: persistentAssignedOnly ? persistentAssignedOnly : false,
      unassignedOnly: persistentUnassignedOnly ? persistentUnassignedOnly : false,
      startDate: persistentStartDate
        ? persistentStartDate.toDate().toUTCString()
        : this.state.startDate.toDate().toUTCString(),
      endDate: persistentEndDate
        ? persistentEndDate.toDate().toUTCString()
        : this.state.endDate.toDate().toUTCString(),
      workflowStatus: 1,
    };

    const response = await getCheckerReports(uri, request);

    if (response.ok) {
      return response.data?.queueItems || [];
    }
    return [];
  };

  handleClose = () => {
    this.setState({ showCheckers: false });
  };

  componentDidMount() {
    this.loadCheckers();
  }

  handleFocusChange = (focusedInput) => this.setState({ focusedInput });

  handleAssignedOnlyCheck(isChecked: any) {
    LocalStorageUtils.setLocalStorageItem(this.assignedOnlyVariable, isChecked);
    this.setState({ assignedOnly: isChecked }, () => {
      this.loadCheckers();
    });
  }

  handleUnassignedOnlyCheck(isChecked: any) {
    LocalStorageUtils.setLocalStorageItem(this.unassignedOnlyVariable, isChecked);
    this.setState({ unassignedOnly: isChecked }, () => {
      this.loadCheckers();
    });
  }

  getFrontSheet = (rowData: CheckersQueueItem) => {
    console.log("workflowItemStep from checker queue", rowData);
    const reportId = rowData?.reportId;

    documentDownloadService.getFrontSheet(reportId);
  };

  handleUnAssign(rowData: CheckersQueueItem) {
    this.props.unAssign(urls.UNASSIGN_WORKFLOW_ITEM_STEP, rowData).then(() => {
      toast.success("Unassigned");
    });
  }

  handleUserCheck(userChecked: any) {
    LocalStorageUtils.setLocalStorageItem(this.userOnlyVariable, userChecked);
    this.setState({ userOnly: userChecked }, () => {
      this.loadCheckers();
    });
  }

  handleDatesChanged(startDate: any, endDate: any) {
    if (startDate && endDate) {
      LocalStorageUtils.setLocalStorageItem(this.startDateVariable, startDate);
      LocalStorageUtils.setLocalStorageItem(this.endDateVariable, endDate);
      this.setState({ startDate, endDate }, () => {
        this.loadCheckers();
      });
    }
  }

  handlePagingCriteriaChange = (pagingCriteria: PagedResultsRequest) => {
    this.setState({ pagingCriteria: pagingCriteria as any }, () => {
      this.loadCheckers();
    });
  };

  handleClearDateSelection = (): void => {
    LocalStorageUtils.removeLocalStorageItem(this.startDateVariable);
    LocalStorageUtils.removeLocalStorageItem(this.endDateVariable);
    this.setState(
      { startDate: moment(QueueStartDate), endDate: moment() },
      () => {
        this.loadCheckers();
      }
    );
  };

  columns: TableColumn<CheckersQueueItem>[] = [
    {
      name: "AVAILABLE ACTIONS",
      selector: (row) => row?.id,
      sortField: "Id",
      sortable: true,
      wrap: true,
      format: (row: CheckersQueueItem) => {
        return (
          <div className="buttonColumn">
            <Provider store={reduxStore}>
              <ViewAllButton reportId={row.reportId} className="" />
            </Provider>
            {"  "}
            {"  "}
            {(row.assignedToUserId == null ||
              row.assignedToUserId == this.props.currentUser.id) && (
                <Button
                  variant="outline-primary"
                  size="sm"
                  onClick={(e) => this.handleAssignAndOpen(row)}
                >
                  {"   "}
                  {row.assignedToUserId == this.props.currentUser.id
                    ? "Continue"
                    : "Review"}
                </Button>
              )}
            {"   "}
            {row.assignedToUserId != null &&
              hasPermission(this.props.currentUser, "Reviewer") && (
                <Button
                  variant="outline-danger"
                  size="sm"
                  onClick={(e) => this.handleUnAssign(row)}
                >
                  {"   "}
                  Unassign
                </Button>
              )}
            {"   "}
            {hasPermission(this.props.currentUser, "Reviewer") && (
              <Button
                variant="outline-dark"
                size="sm"
                onClick={(e) => this.getFrontSheet(row)}
              >
                {"   "}
                Load FrontSheet
              </Button>
            )}
            {"   "}
            {hasPermission(this.props.currentUser, "Reviewer") && (
              <Button
                variant="outline-info"
                size="sm"
                onClick={(e) =>
                  this.handleOpenImage(row.crashReportId, row.documentId)
                }
              >
                {"   "}
                Open Image
              </Button>
            )}
          </div>
        );
      }
    },
    {
      name: "CRASH KEY",
      sortField: "OriginalCrashKey",
      wrap: true,
      selector: (row) => row?.originalCrashKey || "",
      format: (row) => {
        return (
          <div>
            {row?.originalCrashKey || ""}
            <MergedIndicator
              supplementedReports={row.supplementedReports}
              reportsMergedToThis={row.reportsMergedToThis}
            />
            <CompletedIndicator
              completedDate={row.completedDate}
            />
            <DriverReportMergedIndicator
              hasMergedDriverReport={row.hasMergedDriverReport}
            />
          </div>
        );
      },
      sortable: true
    },
    {
      name: "CRASH DATE",
      sortable: true,
      sortField: "DateOfCrash",
      wrap: true,
      selector: (row) =>
        row?.dateOfCrash
          ? moment(row.dateOfCrash).format("MM/DD/yyyy")
          : ""
    },
    {
      name: "COUNTY",
      sortField: "CountyName",
      wrap: true,
      selector: (row) => row?.countyName || "",
      sortable: true
    },
    {
      name: "DOCUMENT ID",
      sortField: "DocumentId",
      wrap: true,
      selector: (row) => row?.documentId || "",
      sortable: true
    },
    {
      name: "ASSIGNED TO",
      sortField: "AssignedToUserName",
      wrap: true,
      selector: (row) => (row?.assignedToUserName || "").split("@")[0],
      sortable: true
    },
    {
      name: "WORKFLOW STATUS",
      sortField: "WorkflowStatus",
      wrap: true,
      selector: (row) => row?.workflowStatus || "Status Indeterminable",
      sortable: true
    },
    {
      name: "PRIORITY",
      sortField: "PriorityNumber",
      wrap: true,
      selector: (row) => row?.priorityName || "",
      sortable: true
    }
  ];

  exportColumnMaps: IExportColumnMap[] = [
    { columnName: "ID", propertyName: "id" },
    { columnName: "CRASH KEY", propertyName: "originalCrashKey" },
    {
      columnName: "DATE OF CRASH",
      propertyName: "dateOfCrash",
      convertMethod: (val) => moment(val).format("MM/DD/YYYY hh:mma")
    },
    { columnName: "COUNTY", propertyName: "countyName" },
    { columnName: "DOCUMENT ID", propertyName: "documentId" },
    { columnName: "ASSIGNED TO", propertyName: "assignedToUserName" },
    { columnName: "WORKFLOW STATUS", propertyName: "workflowStatus" },
    { columnName: "PRIORITY", propertyName: "priorityName" }
  ];

  render() {
    return (
      <React.Fragment>
        <h4>
          {this.props.queueToShow == eCheckersQueue.CheckersReview
            ? "Checkers Queue"
            : "Checkers Review Queue"}
        </h4>
        <Form>
          <Form.Row>
            <Form.Group as={Col} controlId="checkersQueueStartDate">
              <Form.Label>Date of Crash</Form.Label>
              <br />
              <DateRangePicker
                startDate={
                  LocalStorageUtils.getLocalStorageDate(
                    this.startDateVariable
                  ) || this.state.startDate
                } // momentPropTypes.momentObj or null,
                startDateId="checkersQueueStartDate" // PropTypes.string.isRequired,
                endDate={
                  LocalStorageUtils.getLocalStorageDate(this.endDateVariable) ||
                  this.state.endDate
                } // momentPropTypes.momentObj or null,
                endDateId="checkersQueueEndDate" // PropTypes.string.isRequired,
                onDatesChange={({ startDate, endDate }) =>
                  this.handleDatesChanged(startDate, endDate)
                } // PropTypes.func.isRequired,
                focusedInput={this.state.focusedInput} // PropTypes.oneOf([START_DATE, END_DATE]) or null,
                onFocusChange={(focusedInput) =>
                  this.setState({ focusedInput })
                } // PropTypes.func.isRequired,
                isOutsideRange={() => false}
                small={true}
                block={false}
                minimumNights={0}
              />
              {(LocalStorageUtils.getLocalStorageDate(this.startDateVariable) ||
                LocalStorageUtils.getLocalStorageDate(
                  this.endDateVariable
                )) && (
                  <button
                    className="btn btn-outline-danger btn-sm"
                    style={{ fontSize: "14px", marginLeft: "5px" }}
                    title="Clear Date Filter"
                    onClick={this.handleClearDateSelection}
                  >
                    <i className="fa fa-calendar-xmark" />
                  </button>
                )}
            </Form.Group>
            <Form.Group controlId="formBasicCheckbox">
              <Form.Check
                type="checkbox"
                label=" Show only Assigned"
                checked={LocalStorageUtils.getLocalStorageBool(
                  this.assignedOnlyVariable
                )}
                onChange={(e) => this.handleAssignedOnlyCheck(e.target.checked)}
              />
            </Form.Group>
            &nbsp;&nbsp;&nbsp;
            <Form.Group controlId="showUnassignedOnly">
              <Form.Check
                type="checkbox"
                label=" Show only Unassigned"
                checked={LocalStorageUtils.getLocalStorageBool(
                  this.unassignedOnlyVariable
                )}
                onChange={(e) => this.handleUnassignedOnlyCheck(e.target.checked)}
              />
            </Form.Group>
            &nbsp;&nbsp;&nbsp;
            <Form.Group controlId="AssignedMe">
              <Form.Check
                type="checkbox"
                label=" Show only Assigned to Me"
                checked={LocalStorageUtils.getLocalStorageBool(
                  this.userOnlyVariable
                )}
                onChange={(e) => this.handleUserCheck(e.target.checked)}
              />
            </Form.Group>
          </Form.Row>
        </Form>
        <PagedDatatable
          columns={this.columns}
          data={this.props.queueItems || []}
          loadingData={this.props.loadingWorkflowSteps}
          totalDataItems={this.props.totalWorkflowItemSteps}
          exportTitle="Checkers Review Queue"
          exportFileName="CheckersReviewQueue"
          exportColumnMaps={this.exportColumnMaps}
          pagingCriteria={this.state.pagingCriteria}
          updatePagedResults={this.handlePagingCriteriaChange}
          getExportData={this.getExportData}
        ></PagedDatatable>
      </React.Fragment>
    );
  }
}

export function mapStateToProps(state: any) {
  return {
    webServiceURL: state.Application.backendURL,
    currentUser: state.Application.currentUser,
    queueItems: state.CheckersQueue.queueItems,
    loadingWorkflowSteps: state.CheckersQueue.loadingWorkflowSteps,
    totalWorkflowItemSteps: state.CheckersQueue.totalWorkflowItemSteps
  };
}

const mapDispatchToProps = {
  searchCheckersPaged,
  openReportById,
  assignAndOpen,
  unAssign,
  getFrontSheetData
};

export default connect(mapStateToProps, mapDispatchToProps)(CheckersQueuePaged);
